import styled from 'styled-components';

const AdminWrapper = styled.div`
  width: 1410px;
  margin: 0 auto;
`;

export default AdminWrapper;
